import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import useBlogStore from '../store/cmsStore/blogStore';
import Seo from '../components/Seo';

const BlogDetail: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const { selectedBlog, relatedPosts, fetchBlogById } = useBlogStore();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (slug) {
      fetchBlogById(slug);
    }
  }, [slug, fetchBlogById]);

  if (!selectedBlog) {
    return <p>Loading...</p>;
  }

  // Prefer the admin's custom schema.org JSON-LD; fall back to a basic BlogPosting block
  // built from the post itself so every post still gets structured data for SEO.
  const plainTextDescription = (selectedBlog.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  const fallbackSchema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: selectedBlog.title,
    description: selectedBlog.meta_description || selectedBlog.teaser || plainTextDescription.slice(0, 200),
    image: selectedBlog.image || undefined,
    datePublished: selectedBlog.createdAt,
    dateModified: selectedBlog.updatedAt || selectedBlog.createdAt,
    mainEntityOfPage: { '@type': 'WebPage', '@id': `https://www.slammmm.com/blog/${selectedBlog.slug}` },
    author: { '@type': 'Organization', name: 'SLAMMMM', url: 'https://www.slammmm.com/' },
    publisher: {
      '@type': 'Organization',
      name: 'SLAMMMM',
      url: 'https://www.slammmm.com/',
      logo: { '@type': 'ImageObject', url: 'https://www.slammmm.com/assets/logo-BU_zE9SM.webp' },
    },
  });

  return (
          <>
          <Seo
            title={selectedBlog.meta_title || selectedBlog.title}
            description={selectedBlog.meta_description || selectedBlog.teaser || plainTextDescription.slice(0, 160)}
            keywords={selectedBlog.meta_keyword}
            author="SLAMMMM"
            schema={selectedBlog.schema || fallbackSchema}
          />
          <section className="py-60 breadcrumb_section bg-light">
                  <div className="container">
                      <div className="border-bottom pb-lg-5 pb-4">
                          <div className="row">
                              <div className="col-lg-12">
                                  <div className="section_title">
                                      <Link to="/blogs" className="text-decoration-none text-dark fs-6">
                                          <h6 className="font500 mb-0 font19"> <i className="fa-solid fa-arrow-left me-2"></i> Back</h6>
                                      </Link>
                                      <h1 className="mb-0 mt-3">{selectedBlog.title}</h1>

                                  </div>
                                  <p className="mt-4 font18 mb-0">Last Updated: {new Date(selectedBlog.createdAt).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                  })}</p>
                              </div>
                          </div>
                      </div>
                  </div>
              </section>

              <section className="pb-60 blog_details_section bg-light">
              <div className="container" >
              <div className="blog_details_wrapper">
              <div className="blog_details_img_wrapper">
                    <img src={selectedBlog.image} alt="" className="img-fluid blog_details_img" />
                    <div className='blog_details_content_wrapper'>
                    <div className="" dangerouslySetInnerHTML={{ __html: selectedBlog.description }}>
                    
                      
                      </div>
                      <Link to="/signup"><button className="btn btn-primary mt-lg-3 mb-3">Find Your Next Date</button></Link>
                    </div>
                   
                </div>
              </div>
              </div>
              </section>
              <section className="pb-60 blog_related_section bg-light">
                  <div className="container">
                      <div className="section_title">
                          <h2 className="mb-lg-5 mb-3">Related</h2>
                      </div>
                      <div className="row g-4">
                         {relatedPosts.map((post:any) => (
                          <div key={post.id} className="col-lg-4 col-md-6">
                              <Link to={`/blog-details/${post.slug}`} className="text-decoration-none">
                                  <div className="blog_lists_item h-100">
                                      <div className=" blog_lists_item_img2">
                                          <img src={post.image || 'https://via.placeholder.com/300'} alt="" className="img-fluid" />
                                      </div>
                                      <div className="blog_lists_item_cnt">
                                          <h3 className="font28 mb-lg-4 text-dark">
                                          {post.title}
                                          </h3>
                                          <span className="text-primary">Learn More <i className="fa-solid fa-arrow-right"></i></span>
                                      </div>
                                  </div>
                              </Link>
                          </div>
                          ))}
                          
                      </div>
                  </div>
              </section>

          </>


   
  );
};

export default BlogDetail;
